module.exports = __webpack_public_path__ + "static/AD-c7b5bab59dd136ad1b1141866b3b95e1.jpg";